import React from 'react';
import { ToasterProvider, ToasterComponent, ThemeProvider } from '@gravity-ui/uikit';
import { useClientContext } from '@client/lib/ClientContext';
import { Header } from '@components/Header';

export const Root: React.FC<React.PropsWithChildren> = props => {
    const [{ theme, platform }] = useClientContext();

    return (
        <ThemeProvider theme={theme}>
            <Header>
                <ToasterProvider>
                    {props.children}
                    <ToasterComponent mobile={platform === 'mobile'} />
                </ToasterProvider>
            </Header>
        </ThemeProvider>
    );
};
